import { IHttpService } from "../HttpService";
import { parseBooleanValue } from "../..";
import { ISection } from "../../model/formconfiguration/Section";
import { IFormConfigSectionQualifier } from "../../model/formconfiguration/FormConfigSectionQualifier";

export interface IFormSectionService {
  createFormSection(section: ISection): Promise<any>;
  updateFormSection(section: ISection): Promise<any>;
  invalidateFormSection(formType: string, formSectionId: number): Promise<any>;
  createFormConfigSectionQualifier(
    formTypeCode: string,
    formSectionId: number,
    formConfigSectionQualifier: IFormConfigSectionQualifier
  ): Promise<any>;
  updateFormConfigSectionQualifier(
    formTypeCode: string,
    id: number,
    formSectionId: number,
    formConfigSectionQualifier: IFormConfigSectionQualifier
  ): Promise<string>;
}

const FormSectionService = (httpService): IFormSectionService => {
  const _http: IHttpService = httpService;
  const _baseUrl: string = "/api";
  const _formTypesPath = "form-types";
  const _formSectionsPath: string = "form-sections";
  const _qualifiersPath: string = "qualifiers";

  let FormSectionParamsMapper = (section: ISection) => {
    return {
      ...section,
      valid: parseBooleanValue(section.valid),
      orderNumberVisible: parseBooleanValue(section.orderNumberVisible),
      labelVisible: parseBooleanValue(section.labelVisible),
      required: parseBooleanValue(section.required),
      portalAggregate: parseBooleanValue(section.portalAggregate)
    };
  };

  let FormConfigSectionQualifierParamsMapper = (
    formConfigSectionQualifier: IFormConfigSectionQualifier
  ) => {
    return {
      ...formConfigSectionQualifier,
      labelVisible: parseBooleanValue(formConfigSectionQualifier.labelVisible),
      required: parseBooleanValue(formConfigSectionQualifier.required),
      orderNumberVisible: parseBooleanValue(
        formConfigSectionQualifier.orderNumberVisible
      ),
      valid: parseBooleanValue(formConfigSectionQualifier.valid),
      visiblePublic: parseBooleanValue(formConfigSectionQualifier.visiblePublic)
    };
  };

  return {
    async createFormSection(section: ISection) {
      const path = _http.buildPath(
        _baseUrl,
        _formTypesPath,
        section.formTypeCode,
        _formSectionsPath
      );
      const response = await _http.post(path, {
        params: FormSectionParamsMapper(section)
      });
      return _http.toText(response);
    },

    async updateFormSection(section: ISection) {
      const path = _http.buildPath(
        _baseUrl,
        _formTypesPath,
        section.formTypeCode,
        _formSectionsPath,
        section.id.toString()
      );
      const response = await _http.put(path, {
        params: FormSectionParamsMapper(section)
      });
      return _http.toText(response);
    },

    async invalidateFormSection(formTypeCode: string, formSectionId: number) {
      const path = _http.buildPath(
        _baseUrl,
        _formTypesPath,
        formTypeCode,
        _formSectionsPath,
        formSectionId.toString()
      );
      const response = await _http.remove(path);
      return _http.toText(response);
    },

    async createFormConfigSectionQualifier(
      formTypeCode: string,
      formSectionId: number,
      formConfigSectionQualifier: IFormConfigSectionQualifier
    ) {
      const path = _http.buildPath(
        _baseUrl,
        _formTypesPath,
        formTypeCode,
        _formSectionsPath,
        formSectionId.toString(),
        _qualifiersPath
      );
      const response = await _http.post(path, {
        params: FormConfigSectionQualifierParamsMapper(
          formConfigSectionQualifier
        )
      });
      return _http.toText(response);
    },

    async updateFormConfigSectionQualifier(
      formTypeCode: string,
      id: number,
      formSectionId: number,
      formConfigSectionQualifier: IFormConfigSectionQualifier
    ) {
      const path = _http.buildPath(
        _baseUrl,
        _formTypesPath,
        formTypeCode,
        _formSectionsPath,
        formSectionId.toString(),
        _qualifiersPath,
        id.toString()
      );
      const response = await _http.put(path, {
        params: FormConfigSectionQualifierParamsMapper(
          formConfigSectionQualifier
        )
      });
      return _http.toText(response);
    }
  };
};

export default FormSectionService;
